// this enum represents all entrys in the feature table
// this enum can't have more entrys than the actual feature table has
export enum FeatureEnum {
    CanOverridePersonsPerSquareMeterOnStairs = 1,
    CanOverrideSingleSeatFootrest = 2,
    CanOverrideReservationNeededEvaluation = 3,
    CanOverrideHarbourConnectionEvaluation = 4,
    CanOverrideDoubleSeatFootrest = 5,
    CanOverrideBaggageRackLarge = 6,
    CanOverrideBycicleAmountMultiPurposeArea = 7,
    CanOverrideSkiAmountMultiPurposeArea = 8,
    CanOverrideStrollerAmountMultiPurposeArea = 9,
    CanOverrideBenchFootrest = 10,
    CanOverrideBycicleAmountSingleSashDoor = 11,
    CanOverrideSkiAmountSingleSashDoor = 12,
    CanOverrideStrollerAmountSingleSashDoor = 13,
    CanOverrideBycicleAmountDoubleSashDoor = 14,
    CanOverrideSkiAmountDoubleSashDoor = 15,
    CanOverrideStrollerAmountDoubleSashDoor = 16,
    CanShowAdvancedPropertiesPartitionWall = 17,
    CanShowAdvancedPropertiesUnusableSpace = 18,
    CanShowReservationNeededAddProject = 19
}